import parse from "html-react-parser";
import React from "react";
var BlueTextLi = function BlueTextLi(props) { return /*#__PURE__*/ React.createElement("ul", { className: "space-y-2 list-disc mx-6" }, props.contents.map(function (value, index) { return /*#__PURE__*/ React.createElement(BlueTextLiItems, { content: value, key: index }); })); };
var BlueTextLiItems = function BlueTextLiItems(props) { return /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement("p", null, parse(props.content))); };
export default BlueTextLi;
